import React, { Component } from 'react';
import counterpart from 'counterpart';
import './MerchantPassFiles.scss';
import deleteIcon from 'Assets/img/delete-icon.png';

export class MerchantPassFiles extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };

    this.attachBindings();
  }

  attachBindings() {
    this.deleteFile = this.deleteFile.bind(this);
  }

  deleteFile = () => {
    this.props.deleteFile(this.props.keys);
  }

  render() {
    if (this.props.files.status === "PENDING") {

      return (
        <div className="valid-file-type">
          {counterpart('globalTranslate.takeAction.fileName')} {this.props.files.file.name.length > 60 ? this.props.files.file.name.substring(0, 60).concat('...') : this.props.files.file.name}
          <div className="myBars" id={this.props.files.file.name} style={{ width: this.props.width }}>
            {<img src={deleteIcon} alt="icon" className="delete-icon" />}
          </div>
          <div className="seperator-merchant-line-uploading"></div>
        </div>
      );

    } else if (this.props.files.status === "SUCCESS") {

      return (
        <div className="uploaded-file-names-merchant">
          {this.props.files.file.name.length > 60 ? this.props.files.file.name.substring(0, 60).concat('...') : this.props.files.file.name}
          <div className="successFiles" >
            <img src={deleteIcon} alt="icon" className="delete-icon" onClick={this.deleteFile} />
          </div>
          <div className="seperator-merchant-line-file"></div>
        </div>


      );
    }
  }
}

export default MerchantPassFiles;